module.exports = __webpack_public_path__ + "assets/sf-search-icon.9da4e445.svg";